export const LATE = 'LATE';
export const PAY_WITH_DELAY = 'PAY_WITH_DELAY';
export const PAID = 'PAID';
export const CANCELED = 'CANCELED';
export const DONE = 'DONE';
